export const REGISTER_AGENT = 'REGISTER_AGENT'
export const REGISTER_AGENT_SUCCESS = 'REGISTER_AGENT_SUCCESS'
export const REGISTER_AGENT_ERROR = 'REGISTER_AGENT_ERROR'

export const REGISTER_TOKEN = 'REGISTER_TOKEN'
export const REGISTER_TOKEN_SUCCESS = 'REGISTER_TOKEN_SUCCESS'
export const REGISTER_TOKEN_ERROR = 'REGISTER_TOKEN_ERROR'
